<template>
    <div class="card-detalhes-pedido-andamento"> 
        <g-tab-menu @tabChange="tabChange" :items="items" :itemAtivo="itemAtivoTeste">
            
        </g-tab-menu>     
    </div>
</template>

<script>
import PedidoEmAndamentoFluxo from './PedidoEmAndamentoFluxo.js';
export default PedidoEmAndamentoFluxo
</script>

<style scoped>

</style>